import { render } from "./TemplateAddComponent.vue?vue&type=template&id=a083dfa2&scoped=true"
import script from "./TemplateAddComponent.vue?vue&type=script&lang=js"
export * from "./TemplateAddComponent.vue?vue&type=script&lang=js"

import "./TemplateAddComponent.vue?vue&type=style&index=0&id=a083dfa2&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a083dfa2"]])

export default __exports__